"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
exports.SSOService = void 0;
const tslib_1 = require("tslib");
const auth0_spa_js_1 = require("@auth0/auth0-spa-js");
const mobx_1 = require("mobx");
const notification_service_1 = require("../components/notification.toast/notification.service");
const i18n_1 = require("../i18n");
const index_1 = require("./index");
class SSOService {
    constructor() {
        this.__priority = 24;
        this.inFlight = true;
    }
    setUser(user) {
        this.user = user;
    }
    setToken(token) {
        this.token = token;
    }
    get isAuthenticated() {
        return Boolean(this.user);
    }
    init() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            const clientId = index_1.Services.Config.config.get('auth0.client.id');
            const domain = index_1.Services.Config.config.get('auth0.domain');
            if (clientId && domain) {
                this.client = new auth0_spa_js_1.Auth0Client({
                    client_id: clientId,
                    domain,
                    redirect_uri: window.location.origin,
                    audience: `${window.location.origin}/v1/`
                });
                try {
                    //This is ugly but enables us to get the token in Firefox.
                    // const token = await this.client.getTokenWithPopup();
                    const token = yield this.client.getTokenSilently();
                    const user = yield this.client.getUser();
                    index_1.Services.Log.Logger.info('Signed in with Auth0', token);
                    this.setToken(token);
                    this.setUser(user);
                    this.inFlight = false;
                }
                catch (error) {
                    if ((error === null || error === void 0 ? void 0 : error.message) !== 'Login required') {
                        index_1.Services.Log.Logger.error('Auth0 error', error);
                        if (error.message) {
                            notification_service_1.NotificationService.errorAsString(error.message);
                        }
                        else {
                            notification_service_1.NotificationService.error({ key: i18n_1.T.ERROR_GENERAL });
                        }
                    }
                    this.inFlight = false;
                }
            }
            else {
                index_1.Services.Log.Logger.warn('Unable to start SSO Service: missing client ID or domain variable');
                notification_service_1.NotificationService.warn({ key: i18n_1.T.UNABLE_TO_START_SSO_SERVICE });
                this.inFlight = false;
            }
        });
    }
    /**
     * Trigger a login attempt
     * @param options Extra preferences for the login function using {@link RedirectLoginOptions}
     */
    login() {
        return tslib_1.__awaiter(this, arguments, void 0, function* (options = {}) {
            if (this.client) {
                yield this.client.loginWithRedirect(options);
            }
        });
    }
    /**
     * Logs the user out
     * @param federated Logs the user out of their IDP so they will have to full log back in again to access
     * @refer https://auth0.com/docs/authenticate/login/logout/log-users-out-of-idps
     */
    logout() {
        return tslib_1.__awaiter(this, arguments, void 0, function* (federated = false) {
            if (this.client) {
                yield this.client.logout({ federated });
            }
        });
    }
    resetPassword() {
        return tslib_1.__awaiter(this, void 0, void 0, function* () {
            yield index_1.Services.Rest.rest.SSOUser.triggerResetPassword({ email: this.user.email });
        });
    }
}
exports.SSOService = SSOService;
tslib_1.__decorate([
    mobx_1.observable
], SSOService.prototype, "inFlight", void 0);
tslib_1.__decorate([
    mobx_1.observable
], SSOService.prototype, "user", void 0);
tslib_1.__decorate([
    mobx_1.observable
], SSOService.prototype, "token", void 0);
tslib_1.__decorate([
    mobx_1.action
], SSOService.prototype, "setUser", null);
tslib_1.__decorate([
    mobx_1.action
], SSOService.prototype, "setToken", null);
tslib_1.__decorate([
    mobx_1.computed
], SSOService.prototype, "isAuthenticated", null);
//# sourceMappingURL=sso.service.js.map